export const STATUS_TYPE = {
  0: { text: '已删除', color: 'danger' },
  1: { text: '正常', color: 'success' }
};

export const ONLINE_STATUS = {
  1: { text: '在线', color: 'success' },
  0: { text: '离线', color: 'danger' }
};
